import React from 'react';

import * as NotificationService from '../../../services/notification/admin/Notification';

const NotificationContext = React.createContext();
const { Provider, Consumer } = NotificationContext;

class NotificationProvider extends React.Component {
  state = {
    response: null,
  };

  constructor(props) {
    super(props);
    this.home = this.home.bind(this);
    this.editParam = this.editNotification.bind(this);
  }

  async home(data) {
    return new Promise(async (resolve, reject) => {
      await NotificationService.home(data)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  async editNotification(id) {
    return new Promise(async (resolve, reject) => {
      await NotificationService.editNotification(id)
        .then(res => {
          resolve(res);
        })
        .catch(res => {
          reject(res);
        });
    });
  }

  render() {
    const { children } = this.props;

    return (
      <Provider
        value={{
          response: this.state.response,
          home: this.home,
          addParam: this.addParam,
          editParam: this.editNotification,
          updateParam: this.updateParam,
          updateParamValue: this.updateParamValue,
          deleteParam: this.deleteParam,
          dashboard: this.dashboard,
        }}
      >
        {children}
      </Provider>
    );
  }
}

export default NotificationContext;

export { NotificationProvider, Consumer };
